import * as React from "react";

import {
  AppFontPicker,
  AppFontPickerInternalProps,
} from "@1js/acui-font-picker";

import { RibbonControlInternalOnlyProps } from "../RibbonControlProps";

export type RibbonFontPickerInternalProps = AppFontPickerInternalProps &
  RibbonControlInternalOnlyProps;

export const RibbonFontPicker: React.FunctionComponent<RibbonFontPickerInternalProps> =
  (props: RibbonFontPickerInternalProps) => {
    return (
      <AppFontPicker
        {...props}
        dataAutomationType="RibbonFontPicker"
        preventCalloutDismissOnScroll={true}
      />
    );
  };
